import { createElement, FC, useState } from 'react';
import { TooltipArrowStyled, TooltipContainerStyled, TooltipStyled } from './Tooltip.styles';
import { TooltipPosition, TooltipProps } from './Tooltip.types';

const Tooltip: FC<TooltipProps> = ({ children, containerClass, position, text, textStyles }) => {
  const [isShowing, setIsShowing] = useState<boolean>(false);

  const showTooltip = (): void => {
    setIsShowing(true);
  };
  const hideTooltip = (): void => {
    setIsShowing(false);
  };

  return (
    <TooltipContainerStyled className={containerClass} onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
      {children}
      {isShowing && (
        <TooltipStyled css={{ ...textStyles }} position={position}>
          {text}
          <TooltipArrowStyled position={position} as="span"></TooltipArrowStyled>
        </TooltipStyled>
      )}
    </TooltipContainerStyled>
  );
};
Tooltip.defaultProps = {
  children: createElement('div'),
  containerClass: '',
  position: TooltipPosition.BOTTOM,
  text: '',
};

export default Tooltip;
